import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("hr", { class: "separator-hr separator-hr__mx0" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", { class: "separator-hr separator-hr__mx0" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", { class: "separator-hr separator-hr__mx0" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", { class: "separator-hr separator-hr__mx0" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", { class: "separator-hr separator-hr__mx0" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", { class: "separator-hr separator-hr__mx0" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", { class: "separator-hr separator-hr__mx0" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("hr", { class: "separator-hr separator-hr__mx0" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("hr", { class: "separator-hr separator-hr__mx0" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("hr", { class: "separator-hr separator-hr__mx0" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", { class: "separator-hr separator-hr__mx0" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("hr", { class: "separator-hr separator-hr__mx0" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("hr", { class: "separator-hr separator-hr__mx0" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputColor = _resolveComponent("InputColor")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_InputRadio = _resolveComponent("InputRadio")!
  const _component_InputCheckbox = _resolveComponent("InputCheckbox")!
  const _component_InputCheckboxAdicional = _resolveComponent("InputCheckboxAdicional")!
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_InputToggle = _resolveComponent("InputToggle")!
  const _component_InputFile = _resolveComponent("InputFile")!
  const _component_InputTextarea = _resolveComponent("InputTextarea")!
  const _component_InputEmail = _resolveComponent("InputEmail")!
  const _component_InputTab = _resolveComponent("InputTab")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Alert = _resolveComponent("Alert")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (fieldStructure, index) => {
    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
      (fieldStructure.type === 'color')
        ? (_openBlock(), _createBlock(_component_InputColor, {
            key: 0,
            "input-fields": fieldStructure,
            onUpdateSettingCurrent: _ctx.updateFieldsInState
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 2
          }, 1032, ["input-fields", "onUpdateSettingCurrent"]))
        : (fieldStructure.type === 'number')
          ? (_openBlock(), _createBlock(_component_InputNumber, {
              key: 1,
              "input-fields": fieldStructure,
              onUpdateSettingCurrent: _ctx.updateFieldsInState
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 2
            }, 1032, ["input-fields", "onUpdateSettingCurrent"]))
          : (fieldStructure.type === 'radio')
            ? (_openBlock(), _createBlock(_component_InputRadio, {
                key: 2,
                "input-fields": fieldStructure,
                onUpdateSettingCurrent: _ctx.updateFieldsInState
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 2
              }, 1032, ["input-fields", "onUpdateSettingCurrent"]))
            : (fieldStructure.type === 'checkbox')
              ? (_openBlock(), _createBlock(_component_InputCheckbox, {
                  key: 3,
                  "input-fields": fieldStructure,
                  onUpdateSettingCurrent: _ctx.updateFieldsInState
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 2
                }, 1032, ["input-fields", "onUpdateSettingCurrent"]))
              : (fieldStructure.type === 'checkbox-adicional')
                ? (_openBlock(), _createBlock(_component_InputCheckboxAdicional, {
                    key: 4,
                    "input-fields": fieldStructure,
                    onUpdateSettingCurrent: _ctx.updateFieldsInState
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 2
                  }, 1032, ["input-fields", "onUpdateSettingCurrent"]))
                : (fieldStructure.type === 'select')
                  ? (_openBlock(), _createBlock(_component_InputSelect, {
                      key: 5,
                      "input-fields": fieldStructure,
                      onUpdateSettingCurrent: _ctx.updateFieldsInState
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 2
                    }, 1032, ["input-fields", "onUpdateSettingCurrent"]))
                  : (fieldStructure.type === 'toggle')
                    ? (_openBlock(), _createBlock(_component_InputToggle, {
                        key: 6,
                        "input-fields": fieldStructure,
                        onUpdateSettingCurrent: _ctx.updateFieldsInState
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 2
                      }, 1032, ["input-fields", "onUpdateSettingCurrent"]))
                    : (fieldStructure.type === 'file')
                      ? (_openBlock(), _createBlock(_component_InputFile, {
                          key: 7,
                          "input-fields": fieldStructure,
                          onUpdateSettingCurrent: _ctx.updateFieldsInState
                        }, {
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 2
                        }, 1032, ["input-fields", "onUpdateSettingCurrent"]))
                      : (fieldStructure.type === 'textarea')
                        ? (_openBlock(), _createBlock(_component_InputTextarea, {
                            key: 8,
                            "input-fields": fieldStructure,
                            onUpdateSettingCurrent: _ctx.updateFieldsInState
                          }, {
                            default: _withCtx(() => [
                              _hoisted_9
                            ]),
                            _: 2
                          }, 1032, ["input-fields", "onUpdateSettingCurrent"]))
                        : (fieldStructure.type === 'email')
                          ? (_openBlock(), _createBlock(_component_InputEmail, {
                              key: 9,
                              "input-fields": fieldStructure,
                              onUpdateSettingCurrent: _ctx.updateFieldsInState
                            }, {
                              default: _withCtx(() => [
                                _hoisted_10
                              ]),
                              _: 2
                            }, 1032, ["input-fields", "onUpdateSettingCurrent"]))
                          : (fieldStructure.type === 'tab')
                            ? (_openBlock(), _createBlock(_component_InputTab, {
                                key: 10,
                                "input-fields": fieldStructure
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_11
                                ]),
                                _: 2
                              }, 1032, ["input-fields"]))
                            : (fieldStructure.type === 'text')
                              ? (_openBlock(), _createBlock(_component_InputText, {
                                  key: 11,
                                  "input-fields": fieldStructure,
                                  onUpdateSettingCurrent: _ctx.updateFieldsInState
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_12
                                  ]),
                                  _: 2
                                }, 1032, ["input-fields", "onUpdateSettingCurrent"]))
                              : (fieldStructure.type === 'alert')
                                ? (_openBlock(), _createBlock(_component_Alert, {
                                    key: 12,
                                    "input-fields": fieldStructure
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_13
                                    ]),
                                    _: 2
                                  }, 1032, ["input-fields"]))
                                : _createCommentVNode("", true)
    ], 64))
  }), 128))
}